<div class="container" role="main">
    <div class="HmsContainer">
        <div class="row">
            <div class="row HmsInsideContainer">
                <div class="col-md-12">
                    <button type="button" class="greyBtn" (click)="back()" style="font-weight : bold;">Go to Previous
                        Section</button>
                    <button type="button" class="greyBtn ml-5" *ngIf="isInstruction" (click)="openInstruction()"
                        style="font-weight : bold;">Instructions</button>
                    
                    <button type="button" class="orangeBtn ml-5" [disabled]="!isFormsValid" (click)="openAdditionalInvolvedParties()"
                        [ngStyle]="{'background-color': isFormsValid ? primaryColor : 'gray'}">Continue with Involved Party Selection
                    </button>
                </div>
            </div>
            <div class="row HmsInsideContainer">
                <div class="col-md-12">
                    <p role="heading" aria-level="1">Involved Parties</p>
                </div>
                <div class="col-sm-12">
                    <span class="col-sm-2 fs-14">Add information about the Primary Involved Party involved in this referral. Once all required fields are complete, proceed to the next section within the Involved Party Selection Process.</span>
                </div>
            </div>
            <div class="row HmsInsideContainer">
                <div class="col-md-12">
                    <p role="heading" class="blackRibbon" aria-level="1">Primary Involved Party</p>
                </div>
            </div>
            <div class="row HmsInsideContainer">
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <form class="userForm" [formGroup]="involvedPartyFormPart">
                        <div class="col-md-10" >
                            <app-json-form [controlsData]="involvedPartyControl"
                                [formData]="involvedPartyFormPart" [textAreaCol]="30" [textAreaRows]="9"
                                [textAreaCounterPositionClass]="'pull-left'" [showTextInfo] = "false"
                                (valueChangeEvent)="valueChange($event)" [disableControl]="true"></app-json-form>
                        </div>
                    </form>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <form class="referalForm" [formGroup]="referalForm">
                        <div class="col-md-10">
                            <app-json-form [controlsData]="referalFormData.controls" [formData]="referalForm"
                                (valueChangeEvent)="valueChange($event)"></app-json-form>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row HmsInsideContainer" style="padding: 0;">
                <app-provider-details *ngIf="profileMasterTypeKey === 1" [inputDetails]="primaryInvolvedPartyDetails" (formValidationEvent)="formValidationEvent($event)"></app-provider-details>
                <app-member-details *ngIf="profileMasterTypeKey === 2" [inputDetails]="primaryInvolvedPartyDetails" (formValidationEvent)="formValidationEvent($event)"></app-member-details>
                <app-non-enumerated-provider-details *ngIf="profileMasterTypeKey === 3" [inputDetails]="primaryInvolvedPartyDetails" (formValidationEvent)="formValidationEvent($event)"></app-non-enumerated-provider-details>
                <app-non-enumerated-organization-details *ngIf="profileMasterTypeKey === 4" [inputDetails]="primaryInvolvedPartyDetails" (formValidationEvent)="formValidationEvent($event)"></app-non-enumerated-organization-details>
                <app-non-enumerated-individual-details *ngIf="profileMasterTypeKey === 5" [inputDetails]="primaryInvolvedPartyDetails" (formValidationEvent)="formValidationEvent($event)"></app-non-enumerated-individual-details>
            </div>
            <div class="row HmsInsideContainer" *ngIf="isExternalReferringParty == 'Yes'">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <form class="userForm" [formGroup]="additionalForm">
                        <app-json-form [controlsData]="additionalFormData.controls"
                            [formData]="additionalForm" [textAreaCol]="30" [textAreaRows]="2"
                            [textAreaCounterPositionClass]="'pull-left'" [showTextInfo] = "false"
                            (valueChangeEvent)="valueChange($event)"></app-json-form>
                    </form>
                </div>
            </div>

            <div class="row HmsInsideContainer">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <button type="button" class="orangeBtn pull-right" [disabled]="!isFormsValid" (click)="openAdditionalInvolvedParties()"
                        [ngStyle]="{'background-color': isFormsValid ? primaryColor : 'gray'}">Continue with Involved Party Selection
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>